/* eslint-disable react-hooks/exhaustive-deps */
import { format } from "date-fns";
import { Formik } from "formik";
import { CalendarIcon } from "lucide-react";
import React from "react";
import { useTranslation } from "react-i18next";
import DropDownList from "../../components/DropDownList";
import FormError from "../../components/FormError";
import { Icons } from "../../components/icons";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
} from "../../components/ui/alert-dialog";
import { Button } from "../../components/ui/button";
import { Calendar } from "../../components/ui/calendar";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "../../components/ui/card";
import { Label } from "../../components/ui/label";
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "../../components/ui/popover";
import { Separator } from "../../components/ui/separator";
import { Textarea } from "../../components/ui/textarea";
import { cn } from "../../lib/utils";
import fetchData from "../../utils/api";
import { TableReservationValidation } from "../menu/cart/Validation";
import { Config } from "../../utils/config";

export default function TableReservation({
  authToken,
  id,
  restaurantDetail,
  currentSelected,
  setCurrentSelected,
  setIsTableReservation,
  tableReservationCart,
  setTableReservationCart,
  setIsDineIn,
  ssoUserDetails,
  ssoAddress,
}) {
  const [popoverOpen, setPopoverOpen] = React.useState(false);
  const [open, setOpen] = React.useState(false);
  const [cartId, setCartId] = React.useState<any>("");
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [persons, setPersons] = React.useState<any>([]);
  const [timeDropDownList, setTimeDropDownList] = React.useState<any>([]);
  const [dayDropDownList, setDayDropDownList] = React.useState<any>([]);
  const [tablePreferenceList, setTablePreferenceList] = React.useState<any>([]);
  const [selectedDayTime, setSelectedDayTime] = React.useState<any>("");
  const handleTableReservationInfo = async () => {
    try {
      const res = await fetchData({
        url: "cart/table-reservation-info",
        method: "POST",
        token: authToken,
      });
      if (res.status_code === 200) {
        setDayDropDownList(res.data?.table_reservation_days);
        setTimeDropDownList(res.data?.table_reservation_time);
        setTablePreferenceList(
          res.data?.table_reservation_list.length === 0
            ? [Config.env.app.manage_seating_options[3]]
            : Config.env.app.manage_seating_options
                .map((item) => {
                  if (res.data?.table_reservation_list.includes(item.value)) {
                    return item;
                  }
                })
                .filter((item) => item)
        );

        setSelectedDayTime(
          res.data?.table_reservation_time[
            res.data?.table_reservation_days[0]?.label
          ]
        );
        setPersons(res.data?.table_reservation_person_list);
      }
    } catch (error) {
      console.log("error", error);
    }
  };
  React.useEffect(() => {
    handleCheckCart();
    handleTableReservationInfo();
  }, []);

  const handleCheckCart = async () => {
    const cachedCart = localStorage.getItem("cart");
    if (cachedCart) {
      localStorage.removeItem("cart");
      try {
        const body: any = { cart_id: cachedCart };
        const checkCartRes = await fetchData({
          url: "cart/check-cart",
          method: "POST",
          body,
          token: authToken,
        });
        if (checkCartRes.status_code === 200) {
          localStorage.setItem("cart", checkCartRes.data.id);
        }
      } catch (error) {
        console.log("error", error);
      }
    }
    setCartId(cachedCart);
  };

  const handleOrder = ({ selected }) => {
    const url = new URL(window.location.href);
    const params = url.searchParams;
    if (selected === "cart") {
      setTableReservationCart(true);
      if (params.has("type")) {
        params.delete("type");
        params.set("type", "table_booking");
        const newUrl = `${url.origin}${url.pathname}?${params.toString()}`;
        window.history.replaceState(null, "", newUrl);
        setCurrentSelected(selected);
        setIsTableReservation(false);
      }
    } else {
      if (window.REACT_APP_TYPE) {
        delete window.REACT_APP_TYPE;
        window.REACT_APP_TYPE = "in_restaurant";
        setCurrentSelected(selected);
        setIsTableReservation(false);
      }

      if (params.has("type")) {
        params.delete("type");
        params.set("type", "in_restaurant");
        const newUrl = `${url.origin}${url.pathname}?${params.toString()}`;
        window.history.replaceState(null, "", newUrl);
        setCurrentSelected(selected);
        setIsTableReservation(false);
      }
    }
  };

  return (
    <div className="flex justify-center items-center h-screen ">
      {!restaurantDetail.services.table_reservation ? (
        <Label>{t("table_reservation.not_found")}</Label>
      ) : (
        <Card className="lg:w-1/3 w-full">
          <CardHeader>
            <CardTitle>{t("table_reservation.title")}</CardTitle>
          </CardHeader>
          <CardContent>
            <Formik
              enableReinitialize={true}
              initialValues={{
                person: "",
                date: undefined,
                time: "",
                comments: "",
                seating_preference:
                  tablePreferenceList.length > 0
                    ? tablePreferenceList[0].value
                    : "",
              }}
              validationSchema={TableReservationValidation}
              onSubmit={async (values: any) => {
                setIsLoading(true);
                const cachedCart = localStorage.getItem("cart") || cartId;
                try {
                  const filterDate = format(values.date, "dd/MM/yy");
                  const body: any = {
                    cart_id: cachedCart,
                    person: values.person,
                    date: filterDate,
                    time: values.time,
                    comments: values.comments,
                    seating_preference: values.seating_preference,
                    only_table_reservation: true,
                  };
                  const res = await fetchData({
                    url: "cart/table-reservation",
                    method: "POST",
                    body,
                    token: authToken,
                  });
                  if (res.status_code === 200) {
                    setIsLoading(false);
                    if (
                      restaurantDetail.tableReservation
                        .allow_guest_pre_order === true
                    ) {
                      setOpen(true);
                    } else {
                      setTableReservationCart(true);
                      const url = new URL(window.location.href);
                      const params = url.searchParams;

                      if (params.has("type")) {
                        params.delete("type");
                        const newUrl = `${url.origin}${
                          url.pathname
                        }?${params.toString()}`;
                        window.history.replaceState(null, "", newUrl);
                        setCurrentSelected("cart");
                        setIsTableReservation(false);
                      }
                    }
                  }
                } catch (error) {
                  console.log("error", error);
                }
              }}
            >
              {({ errors, touched, setFieldValue, values, handleSubmit }) => (
                <form onSubmit={handleSubmit}>
                  <div className="grid gap-2">
                    <div className="grid gap-2 w-full">
                      <Label className="text-left" htmlFor="date">
                        {t("cart.table_size.form.add_persons")}{" "}
                        <span className="text-red-500">*</span>
                      </Label>
                      <div>
                        <DropDownList
                          id="person"
                          label={t("cart.table_size.form.persons")}
                          placeholder={t(
                            "cart.table_size.form.add_persons_placeholder"
                          )}
                          data={persons}
                          value={values.person}
                          onValueChange={(e: any) => {
                            setFieldValue("person", e, true);
                          }}
                          disabled={isLoading}
                        />

                        {errors.person && touched.person ? (
                          <FormError msg={t(errors.person as string)} />
                        ) : null}
                      </div>
                    </div>
                    <div className="grid gap-2 w-full">
                      <Label className="text-left" htmlFor="date">
                        {t("cart.available_time_choice.form.date")}{" "}
                        <span className="text-red-500">*</span>
                      </Label>
                      {/* <div>
                        <DropDownList
                          id="date"
                          label={t("cart.available_time_choice.form.date")}
                          placeholder={t(
                            "cart.available_time_choice.form.date_placeholder"
                          )}
                          data={dayDropDownList}
                          value={values.date}
                          onValueChange={(e: any) => {
                            setFieldValue("date", e, true);
                            setFieldValue("time", "", true);

                            const day: any = dayDropDownList.find(
                              (c) => c.value === e
                            )?.label;
                            setSelectedDayTime(timeDropDownList[day]);
                          }}
                          disabled={isLoading}
                        />

                        {errors.date && touched.date ? (
                          <FormError msg={t(errors.date as string)} />
                        ) : null}
                      </div> */}
                      <div>
                        <Popover
                          open={popoverOpen}
                          onOpenChange={setPopoverOpen}
                        >
                          <PopoverTrigger asChild>
                            <Button
                              id="date"
                              variant={"outline"}
                              className={cn(
                                "w-full justify-start text-left font-normal",
                                !values.date && "text-muted-foreground"
                              )}
                            >
                              <CalendarIcon className="mr-2 h-4 w-4" />
                              {values.date ? (
                                <>
                                  {format(values.date, "cccc, MMMM do, yyyy")}
                                </>
                              ) : (
                                <span>
                                  {t(
                                    "cart.available_time_choice.form.pick_date"
                                  )}
                                </span>
                              )}
                            </Button>
                          </PopoverTrigger>
                          <PopoverContent className="w-auto p-0" align="start">
                            <Calendar
                              id="date"
                              fromDate={new Date()}
                              toDate={
                                new Date(
                                  new Date().setMonth(
                                    new Date().getMonth() +
                                      (Number(
                                        restaurantDetail?.tableReservation
                                          ?.maximum_time_in_advance
                                      ) ?? 1)
                                  )
                                )
                              }
                              initialFocus
                              mode="single"
                              selected={values.date}
                              onSelect={(date) => {
                                // Handle null/undefined case explicitly
                                if (!date) {
                                  setFieldValue("date", "", true);
                                  setFieldValue("time", "", true);
                                  return;
                                }

                                // Ensure we're working with a Date object
                                const selectedDate = new Date(date);

                                // Update the form values
                                setFieldValue("date", selectedDate, true);
                                setFieldValue("time", "", true);

                                // Format the date for dropdown matching
                                const formattedValue = format(
                                  selectedDate,
                                  "dd/MM/yy"
                                );

                                // Find the corresponding day in the dropdown list
                                const day = dayDropDownList.find(
                                  (c) => c.value === formattedValue
                                )?.label;

                                // Set the selected day time
                                if (day && timeDropDownList[day]) {
                                  setSelectedDayTime(timeDropDownList[day]);
                                }
                                setPopoverOpen(false);
                              }}
                            />
                          </PopoverContent>
                        </Popover>
                        {errors.date && touched.date ? (
                          <FormError msg={t(errors.date as string)} />
                        ) : null}
                      </div>
                    </div>
                    <div className="grid gap-2 w-full">
                      <Label className="text-left" htmlFor="time">
                        {t("cart.available_time_choice.form.time")}{" "}
                        <span className="text-red-500">*</span>
                      </Label>
                      <div>
                        <DropDownList
                          id="time"
                          label={t("cart.available_time_choice.form.time")}
                          placeholder={t(
                            "cart.available_time_choice.form.time_placeholder"
                          )}
                          data={selectedDayTime}
                          value={values.time}
                          onValueChange={(e: any) => {
                            setFieldValue("time", e, true);
                          }}
                          disabled={isLoading}
                          exceptTranslation={true}
                        />
                        {errors.time && touched.time ? (
                          <FormError msg={t(errors.time as string)} />
                        ) : null}
                      </div>
                    </div>
                    <div className="grid gap-2 w-full">
                      <Label className="text-left" htmlFor="time">
                        {t("cart.seating_preference.title")}{" "}
                        <span className="text-red-500">*</span>
                      </Label>
                      <div>
                        <DropDownList
                          id="seating_preference"
                          label={t("cart.seating_preference.title")}
                          placeholder={t("cart.seating_preference.placeholder")}
                          data={tablePreferenceList}
                          value={values.seating_preference}
                          onValueChange={(e: any) => {
                            setFieldValue("seating_preference", e, true);
                          }}
                          disabled={
                            isLoading || tablePreferenceList.length === 1
                          }
                        />
                        {errors.seating_preference &&
                        touched.seating_preference ? (
                          <FormError
                            msg={t(errors.seating_preference as string)}
                          />
                        ) : null}
                      </div>
                    </div>
                    <div className="grid gap-2 w-full">
                      <Label className="text-left" htmlFor="comments">
                        {t("cart.available_time_choice.form.comments")}
                      </Label>
                      <div>
                        <Textarea
                          id="comments"
                          placeholder={t(
                            "cart.available_time_choice.form.comments_placeholder"
                          )}
                          value={values.comments}
                          onChange={(e: any) => {
                            setFieldValue("comments", e.target.value, true);
                          }}
                          disabled={isLoading}
                        />
                        {errors.comments && touched.comments ? (
                          <FormError msg={t(errors.comments as string)} />
                        ) : null}
                      </div>
                    </div>
                    <Separator />
                    <div className="flex justify-between w-full space-x-2">
                      <div>
                        <Label>
                          {t("table_reservation.description_1")}{" "}
                          {
                            restaurantDetail?.tableReservation
                              ?.when_guest_are_late
                          }{" "}
                          {t("table_reservation.description_2")}
                        </Label>
                      </div>
                      <div>
                        <Button disabled={isLoading} type="submit">
                          {isLoading && (
                            <Icons.spinner className="mr-2 h-4 w-4 animate-spin" />
                          )}
                          {t("next")}
                        </Button>
                      </div>
                    </div>
                  </div>
                </form>
              )}
            </Formik>
          </CardContent>
        </Card>
      )}
      <AlertDialog open={open} onOpenChange={(isOpen) => setOpen(isOpen)}>
        <AlertDialogContent>
          <AlertDialogHeader>
            {t("table_reservation.alert.title")}
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogAction
              onClick={() => handleOrder({ selected: "menu" })}
            >
              {t("table_reservation.alert.order_now")}
            </AlertDialogAction>
            <AlertDialogCancel
              onClick={() => handleOrder({ selected: "cart" })}
            >
              {t("table_reservation.alert.no_order")}
            </AlertDialogCancel>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </div>
  );
}
